import CuentaCrud from './CuentaCrud'
export {CuentaCrud}
export default CuentaCrud
